




































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import LineRegistButton from '../student/register/LineRegistButton.vue';
import PagesMixin from '../components/organisms/PagesMixin';
import { LocalData } from '../utils/LocalData';

@Component({ components: { LineRegistButton } })
export default class DemoPage extends Mixins(PagesMixin) {
  private isTestOn = false;

  private version = '';
  studentLoginCO() {
    this.$router.push({ path: '/test-user-student-login-page?building=co01' });
  }

  studentMailRegistCO() {
    this.$router.push({ path: '/student-mail-register-page?building=co01' });
  }

  teacherTopCO() {
    this.$router.push({ path: '/test-user-teacher-login-page?building=co01' });
  }

  teacherRegistCO() {
    this.$router.push({ path: '/teacher-term-of-use-page?building=co01' });
  }

  adminCoTop() {
    this.$router.push({ path: '/admin-login-page?building=co01' });
  }

  adminDaTop() {
    this.$router.push({ path: '/admin-login-page?building=da01' });
  }

  adminTestTop() {
    this.$router.push({ path: '/admin-login-page?building=test' });
  }

  studentLogin() {
    this.$router.push({ path: '/test-user-student-login-page?building=test' });
  }

  teacherTop() {
    this.$router.push({ path: '/test-user-teacher-login-page?building=test' });
  }

  teacherRegist() {
    this.$router.push({ path: '/teacher-term-of-use-page?building=test' });
  }
  created() {
    this.version = LocalData.getLocalVersion();
  }
}
